import {
  Box,
  Flex,
  JaneGoldIcon,
  TagFilledIcon,
  Typography,
} from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { useSpecialDetailContext } from './context';

import styles from './SpecialDetail.module.css';

export const SpecialDetailCallout = ({
  calloutText,
  isGold,
}: {
  calloutText: string;
  isGold?: boolean;
}) => {
  const { scrolledFromTop } = useSpecialDetailContext();

  return (
    <Flex
      background={
        scrolledFromTop ? 'grays-white' : isGold ? 'gold-light' : 'sunset-light'
      }
      alignItems="center"
      justifyContent="center"
      className={clsx(styles['specialDetail__transition'], {
        [styles['specialDetailCallout__borderGold']]:
          !scrolledFromTop && isGold,
        [styles['specialDetailCallout__border']]: !scrolledFromTop && !isGold,
      })}
      borderRadius="sm"
      width="100%"
      p={scrolledFromTop ? 0 : 16}
      gap={12}
    >
      <Box>
        {isGold ? (
          <JaneGoldIcon size="lg" />
        ) : (
          <TagFilledIcon size="lg" color="sunset" />
        )}
      </Box>

      <Typography branded variant="body-semibold">
        {calloutText}
      </Typography>
    </Flex>
  );
};
